import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import {
  dropBoolean,
  dropGrauInstrucao,
  dropCategoriaCnh,
  dropRacaCor,
  dropReligiao,
  dropHabitacao,
} from 'utils/drops';
import Input from 'components/Input';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import InputMask from 'components/InputMask';
import Title from '../Components/Title';

const Cadastro = ({ loading, funcionario = {}, onSubmit }) => {
  const defaultValues = {
    rotina: 'PessoalCadastro',
    entidade_id: funcionario?.entidade_id,
    nmsocial: '',
    grauinstr: null,
    estudante: null,
    categoriacnh: null,
    dtprihab: null,
    deficiente: null,
    trabaposent: null,
    racacor: null,
    religiao: null,
    doador: null,
    habitacao: null,
  };
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    if (funcionario) {
      const merged = Object.keys(defaultValues).reduce((acc, key) => {
        acc[key] = funcionario[key] ?? defaultValues[key];
        return acc;
      }, {});
      reset(merged);
    }
  }, [funcionario, reset]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title title="Identificação Pessoal" disableMargin />
      </Grid>
      <Grid item xs={12}>
        <Input name="nmsocial" control={control} label="Nome Social" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="grauinstr"
          control={control}
          label="Grau de Instrução"
          options={dropGrauInstrucao}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="estudante"
          label="Estudante"
          control={control}
          options={dropBoolean}
        />
      </Grid>
      <Grid item xs={12}>
        <Title title="CNH" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          control={control}
          name="categoriacnh"
          label="Categoria da CNH"
          options={dropCategoriaCnh}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputMask
          type="date"
          name="dtprihab"
          control={control}
          label="Data da 1ª Habilitação"
        />
      </Grid>
      <Grid item xs={12}>
        <Title title="Condição de Trabalho" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="deficiente"
          control={control}
          options={dropBoolean}
          label="Pessoa com deficiência (PCD)"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="trabaposent"
          control={control}
          options={dropBoolean}
          label="Trabalha Após Aposentadoria"
        />
      </Grid>
      <Grid item xs={12}>
        <Title title="Informações Complementares" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="racacor"
          control={control}
          label="Raça / Cor"
          options={dropRacaCor}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="religiao"
          label="Religião"
          control={control}
          options={dropReligiao}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="doador"
          control={control}
          options={dropBoolean}
          label="Doador de órgãos"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Dropdown
          name="habitacao"
          label="Tipo de Habitação"
          control={control}
          options={dropHabitacao}
        />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          color="primary"
          variant="contained"
          loading={loading}
          onClick={handleSubmit(onSubmit)}
        >
          Salvar
        </Button>
      </Grid>
    </Grid>
  );
};

export default Cadastro;
